import React, { useMemo, useState, useEffect } from 'react'
import FilterDropdown from 'live/components/forms/ui/filter-dropdown'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import Select, { components } from 'react-select'
import './filters.scss'

export type DropdownOptions = {
    title: string,
    field: string,
    options: any[]
}

type IProps = {
    options: DropdownOptions[],
    callback(filters: any): Promise<void>
}

export const DropdownFilters = ({options, callback}: IProps) => {

    const [selected, setSelected] = useState(undefined)
    const [appliedFilters, setAppliedFilters] = useState(undefined)
    const [isAppling, setIsAppling] = useState<boolean>()

    const apply = () => {
        setIsAppling(true)
        setAppliedFilters(selected)
        
        const indexInterval = setInterval(() => {            
            callback(selected).then(res => {
                setIsAppling(false)
                clearInterval(indexInterval);
            })
        }, 1000);
    }

    const removeAll = () => {
        setSelected({})
        setAppliedFilters({})
        callback({})
    }

    const onChange = (target, field) => {
        const aux = {...selected}        
        aux[field] = {values: []}

        target.forEach(ele => aux[field].values.push(ele))

        if(aux[field].values.length === 0) delete aux[field]

        setSelected(aux)
    }

    const onCloseDropdown = () => {        
        setSelected(appliedFilters)
    }

    const isDisabled = () => {
        return selected === undefined || isAppling
    }

    return (
        <FilterDropdown                                            
            hideTitle={true}
            disableTooltip={true} 
            onHide={onCloseDropdown}   
            containerClassName="poi-override-dropdown"                                       
            btnLabel={
                <span>
                    <i className={`${appliedFilters && Object.keys(appliedFilters).length > 0 ? 'fas' : 'far'} fa-filter`} />                                                                                                    
                </span>
            }            
        >
            <StyleContainer>
                {
                    options?.map(({title, options, field}, index) => {
                        return (
                            <ContainerSelect key={index}>
                                <div className="wrapper-select">
                                    <label>{i18n(title)}</label>

                                    <Select
                                        menuIsOpen={true}
                                        multi={true}       
                                        placeholder={i18n('Select')}                                 
                                        value={selected && selected[field]?.values}
                                        onChange={target => onChange(target, field)}                                        
                                        options={options}
                                        className="basic-multi-select"
                                        />
                                </div>

                            </ContainerSelect>
                        )
                    })
                }
            </StyleContainer>
            <StyleContainerBtn>
                <button disabled={isDisabled()} className={`custom-btn custom-btn-apply ${isDisabled() && 'custom-btn-disabled'}`} onClick={apply}>
                    {isAppling ? <i className="fas fa-spinner fa-spin"></i> : <></>}
                    {i18n('Apply')}
                </button>

                <button disabled={selected === undefined} className='custom-btn custom-btn-remove' onClick={removeAll}>
                    {i18n('Remove filters')}
                </button>
            </StyleContainerBtn>
        </FilterDropdown>
    )
}

export default DropdownFilters;

const StyleContainer = styled.div`
    overflow: auto;
    padding: 16px 16px 0 16px;


    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: #bac0cb;
        border-radius: 10px;
    }
`

const StyleContainerBtn = styled.div`
    padding: 10px 15px;
    display: flex;

    .custom-btn{
        border: none;
        flex: 1;
        padding: 4px 0;
        border-radius: 3px 3px;
    }

    .custom-btn-apply{
        color: ${({ theme }) => theme['gray-0']};
        background: ${({ theme }) => theme['blue-500']};
    }
   
    .custom-btn-remove{
        color: ${({ theme }) => theme['blue-500']};
        background: ${({ theme }) => theme['gray-0']};
    }

    .custom-btn-disabled{
        opacity: 0.7;
    }
`

const ContainerSelect = styled.div`
    margin-bottom: 12px;
`